import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Volume2 } from 'lucide-react';
import UnifiedPage from './components/UnifiedPage';
import './index.css';

export default function App() {
  return (
    <div className="app-wrapper">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0e1320',
            color: '#f1f5f9',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 10,
            fontSize: '0.85rem',
          },
          success: { iconTheme: { primary: '#4ade80', secondary: '#0e1320' } },
          error: { iconTheme: { primary: '#f87171', secondary: '#0e1320' } },
        }}
      />

      {/* ── Navbar ── */}
      <nav className="navbar" style={{ marginBottom: 40 }}>
        <div className="container navbar-inner" style={{ justifyContent: 'center' }}>
          <div className="navbar-brand">
            <div className="brand-icon">
              <Volume2 size={18} color="#fff" />
            </div>
            <span className="brand-name">Piper Voice</span>
          </div>
        </div>
      </nav>

      <main className="container">
        <UnifiedPage />
      </main>
    </div>
  );
}
